import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-tooltip-popover',
  templateUrl: './ui-tooltip-popover.component.html',
  styleUrls: ['./ui-tooltip-popover.component.css']
})
export class UiTooltipPopoverComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
